@if (pagination.total_items > 0) {
  <div class="d-flex justify-content-between align-items-center mt-3 p-2 bg-light rounded">
    
    <div class="d-flex align-items-center me-3">
      <label for="pageSizeSelect" class="form-label me-2 mb-0 small text-muted">
        {{ 'COMMON.PAGINATION.PER_PAGE' | translate }}
      </label>
      <select 
        id="pageSizeSelect"
        class="form-select form-select-sm" 
        [ngModel]="pagination.per_page" 
        (ngModelChange)="onPageSizeChange($event)"
      >
        @for (size of pageSizeOptions; track size) {
          <option [ngValue]="size">{{ size }}</option>
        }
      </select>
    </div>
    <span class="text-muted small mx-3">
      {{ 'COMMON.PAGINATION.PAGE' | translate }} 
      {{ pagination.page }} / {{ pagination.total_pages }} ({{ pagination.total_items }} {{ 'COMMON.PAGINATION.TOTAL_ITEMS' | translate }})
    </span>

    <div class="btn-group" role="group">
      <button 
        title="{{ 'COMMON.PAGINATION.FIRST_PAGE' | translate }}"
        class="btn btn-sm btn-outline-secondary" 
        (click)="onPageChange(1)" 
        [disabled]="pagination.page === 1"
      >
        <i class="bi bi-chevron-bar-left"></i>
      </button>
      
      <button 
        title="{{ 'COMMON.PAGINATION.PREVIOUS' | translate }}"
        class="btn btn-sm btn-outline-secondary" 
        (click)="onPageChange(pagination.page - 1)" 
        [disabled]="!pagination.has_prev"
      >
        <i class="bi bi-chevron-left"></i>
      </button>

      @for (page of getPages(); track page) {
        @if (page === '...') {
          <span class="btn btn-sm btn-outline-secondary disabled">...</span>
        } @else {
          <button 
            class="btn btn-sm"
            [ngClass]="{
              'btn-primary': page === pagination.page, 
              'btn-outline-secondary': page !== pagination.page
            }"
            (click)="onPageChange(page)" 
            [disabled]="page === pagination.page"
          >
            {{ page }}
          </button>
        }
      }

      <button 
        title="{{ 'COMMON.PAGINATION.NEXT' | translate }}"
        class="btn btn-sm btn-outline-secondary" 
        (click)="onPageChange(pagination.page + 1)" 
        [disabled]="!pagination.has_next"
      >
        <i class="bi bi-chevron-right"></i>
      </button>
      
      <button 
        title="{{ 'COMMON.PAGINATION.LAST_PAGE' | translate }}"
        class="btn btn-sm btn-outline-secondary" 
        (click)="onPageChange(pagination.total_pages)" 
        [disabled]="pagination.page === pagination.total_pages"
      >
        <i class="bi bi-chevron-bar-right"></i>
      </button>
    </div>
  </div>
} @else {
  <div class="alert alert-info mt-3">
    {{ 'COMMON.ERROR.NO_DATA' | translate }}
  </div>
}